module.exports = __webpack_public_path__ + "img/20.fc439d08.png";